import axios from "axios";

export const state = {
    optionalfeepayments: [],
};

export const getters = {
    optionalfeepayments: state => state.optionalfeepayments,
};

export const mutations = {
    setOptionalFees(state, newValue) {
        state.optionalfeepayments = newValue
    },
}; 

export const actions = {
    fetchOptionalFeesPayments({ commit }) {
        axios.get('/optionalfeespayments').then(res => {
            commit('setOptionalFees', res.data.payments);
        })
    },
    filterOptionalFeesPayments({commit}, {schoolterm,year,fees}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        formData.append("fees", fees);
        let url = "/filteroptionalfeespayments";
        axios.post(url, formData).then((response) => {
            commit('setOptionalFees', response.data.payments)
        })
    },
};
